"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorage = void 0;
var IndexedDbStorage_1 = require("./IndexedDbStorage");
var InMemoryStorage_1 = require("./InMemoryStorage");
var inMemoryStorage = new InMemoryStorage_1.InMemoryStorage();
function localStorage() {
    if (typeof self === "object" && self.indexedDB) {
        return new IndexedDbStorage_1.IndexedDbStorage();
    }
    if (typeof window === "object" && window.localStorage) {
        return window.localStorage;
    }
    return inMemoryStorage;
}
exports.localStorage = localStorage;
//# sourceMappingURL=localStorage.js.map